import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import VehicleBuilder from './VehicleBuilder';

// Actions
import {
  selectMake,
  selectYear,
  selectModel,
  selectTrim,
  selectTransmission,
  selectDriveType,
  selectEngineType,
  selectEngineSize,
  restartVehicleFrom,
  validateTrimData,
  selectQuickApptOptions
} from 'store/reducers/appointment/actions';
import { goTo } from 'store/reducers/navigation/actions';
import { gtmIsIDK } from 'store/reducers/gtm/actions';
import {
  setIdkSelected,
  setShowMobileFooter,
  setVehiclePageRevisit
} from 'store/reducers/userInteractions/actions';
import { loadServices } from 'store/reducers/service/actions';
import { setExactMileageFlag } from 'store/reducers/packages/actions';

// Selectors
import {
  makes,
  getDealerCountryCode,
  getShowMileage,
  getShowRegDate,
  getShowLastLane
} from 'store/reducers/dealerSettings/selectors';
import { years } from 'store/reducers/years/selectors';
import {
  getAppFlow,
  getIdkSelected,
  getVehiclePageRevisit,
  getLocalizedQuickApptService
} from 'store/reducers/userInteractions/selectors';
import { modelsSelector } from 'store/reducers/models/selectors';
import { getApptAdvisorsAndTranspOptions } from 'store/reducers/apptOptions/actions';
import {
  trims,
  transmissions,
  engineTypes,
  driveTypes,
  engineSizes,
  hasIDK,
  getTrimsData,
  getShowTrimsLane
} from 'store/reducers/trims/selectors';
// @TODO: refactor isAlertEnabled selector to be more understanding,
// Used for FIND ME flow when phone no. has no vehicles
import { isAlertEnabled } from 'store/reducers/alert/selectors';
import {
  getCustomerPhone,
  getCustomerEmail,
  getVehicle,
  vehicleEditableEnabled,
  isIDK
} from 'store/reducers/appointment/selectors';
import { selectors as socialSelectors } from 'store/reducers/user/social/';
import { selectors as userSelectors } from 'store/reducers/user/';
import { currentPath } from 'store/reducers/navigation/selectors';
import { getIsQuoteAppt } from 'store/reducers/quoteAppt/selectors';

// Utils
import { undefinedToTrue } from 'utils/varValidation';

const mapStateToProps = state => ({
  isIdkSelected: getIdkSelected(state),
  trimsData: getTrimsData(state),
  appFlow: getAppFlow(state),
  vehicle: getVehicle(state),
  makes: makes(state),
  years: years(state),
  models: modelsSelector(state),
  trims: trims(state),
  transmissions: transmissions(state),
  engineTypes: engineTypes(state),
  driveTypes: driveTypes(state),
  engineSizes: engineSizes(state),
  isAlertEnabled: isAlertEnabled(state),
  showMileage: undefinedToTrue(getShowMileage(state)),
  showRegDate: getShowRegDate(state),
  showLastLane: getShowLastLane(state),
  vehiclePageRevisit: getVehiclePageRevisit(state),
  getCustomerPhone: getCustomerPhone(state),
  getCustomerEmail: getCustomerEmail(state),
  dealerCountryCode: getDealerCountryCode(state),
  isPartiallySignedIn: socialSelectors.isPartiallySignedIn(state),
  isLoggedIn: userSelectors.isLoggedIn(state),
  hasIDK: hasIDK(state),
  isIDK: isIDK(state),
  vehicleEditableEnabled: vehicleEditableEnabled(state),
  showTrimsLane: getShowTrimsLane(state),
  localizedQuickApptService: getLocalizedQuickApptService(state),
  currentPath: currentPath(state),
  isQuoteAppt: getIsQuoteAppt(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selectMake,
      selectYear,
      selectModel,
      selectTrim,
      selectTransmission,
      selectDriveType,
      selectEngineType,
      selectEngineSize,
      validateTrimData,
      restartVehicleFrom,
      getApptAdvisorsAndTranspOptions,
      loadServices,
      goTo,
      setIdkSelected,
      setShowMobileFooter,
      setVehiclePageRevisit,
      gtmIsIDK,
      selectQuickApptOptions,
      setExactMileageFlag
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(VehicleBuilder);



// WEBPACK FOOTER //
// ./src/components/organisms/VehicleBuilder/VehicleBuilderContainer.js